import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';


const LaboratoryCategoryCollapsible = ({ category, config, isCollapsed, onToggleCollapse }) => {
  const title = config?.title || category.toUpperCase();

  return (
    <div className="laboratory-category-collapsible">
      <div
        className="laboratory-category-header"
        role="button"
        tabIndex={0}
        onClick={() => onToggleCollapse?.(category)}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onToggleCollapse?.(category);
          }
        }}
      >
        {isCollapsed ? (
          <>
            <span className="laboratory-category-title">{title}</span>
            <CaretDownOutlined />
          </>
        ) : (
          <>
            <span className="laboratory-category-title">{title}</span>
            <CaretUpOutlined />
          </>
        )}
      </div>

      {!isCollapsed && (
        <div className="laboratory-category-column-headers">
          <div className="laboratory-category-column-name"></div>
          <div className="laboratory-category-column-result">RESULTADO</div>
          <div className="laboratory-category-column-unit">UNIDAD</div>
          <div className="laboratory-category-column-reference">RANGO REFERENCIA</div>
        </div>
      )}
    </div>
  );
};

export default LaboratoryCategoryCollapsible;
